import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import Carosle from "../../Components/Carosle";
import CarRentalLoader from "../../Components/Loaders/CarRentalLoader";
import {
  ShowRestaurantCategories,
  CallWaiter,
} from "../../API/In-Room-DiningAPI";
import Search from "../../Components/Search";
import { Fade, Zoom } from "react-reveal";
import HeaderInnerInDining from "../../Components/HeaderInnerInDining";
import CombImg from "../../assets/images/cambo_meal.jpeg";
import BannerHome from "../../new-components/banner-home/BannerHome";
import { t } from "i18next";
import { ThemeContext } from "../../context/ThemeContext";
import { Modal, Button, Form } from "react-bootstrap";
import { Toast } from "primereact/toast";
import axios from "../../axios";
import Title from "../../new-components/title/Title";

function InDiningScan() {
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const params = useParams();
  const navigate = useNavigate();
  // console.log("location.state?.lang", location.state?.metadata);
  // Set when the guest picked this restaurant from the dine-in restaurants
  // list, i.e. this is not the first page, so the header shows a back button.
  // Absent when we landed here directly (single restaurant / direct QR scan),
  // where the header shows the language select instead.
  const fromRestaurantsList = location.state?.fromRestaurantsList === true;
  const languages = JSON.parse(localStorage.getItem("languages"));
  const lang = localStorage.getItem("lang");
  const get_open_check_available = localStorage.getItem(
    "get_open_check_available",
  );
  // console.log(get_open_check_available, "check");
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  const business_name = localStorage.getItem("business_name");
  const type = localStorage.getItem("type");
  const [streetAddress, setStreetAddress] = useState("");

  let hideIcon = false;

  let restaurant;
  let restaurantCategories;
  let images = [];
  let isVideo = false;
  let bgColor;
  let color;
  let has_combo_meals;
  let text;
  let restaurant_info;
  let terms_and_conditions;
  let require_room_number;
  let isbooking = "";

  console.log("params.id", params.id);
  const { data, isLoading, error } = ShowRestaurantCategories(
    room_uuid,
    params.id,
    lang,
    isbooking,
  );

  if (!isLoading) {
    // console.log("stata", data.data.status);
    if (data.data.status == false) {
      // navigate(`/${room_uuid}/qr-scan`);
    } else if (!error) {
      restaurant = data.data.data;
      restaurantCategories = restaurant.categories;
      has_combo_meals = restaurant.has_combo_meals;
      require_room_number = restaurant.require_room_number;
      terms_and_conditions = restaurant.restaurant.terms_and_conditions;
      restaurant_info = restaurant.restaurant;
      isVideo = restaurant.restaurant.real_video ? true : false;
      if (restaurant.restaurant.real_video) {
        if (restaurant.banners?.length > 0) {
          images = [
            { image: restaurant.restaurant.real_video },
            ...restaurant.banners,
          ];
        }
      } else {
        if (restaurant.banners?.length > 0) {
          images = restaurant.banners;
        }
      }
      color = data.data.data.color;
      bgColor = data.data.data.header_color;
      text = data.data.data.center_header;

      if (type == "in_dining") {
        if (restaurant_info?.can_order == false) {
          hideIcon = true;
        }
      }
      if (restaurantCategories?.length == 1) {
        if (restaurantCategories[0]?.count_sub_categories != 0) {
          navigate(
            `/${room_uuid}/rstauran-menu-subcategories/${params.id}/${restaurantCategories[0].id}`,
            { replace: true },
          );
        } else {
          navigate(
            `/${room_uuid}/rstauran-menu-items/${params.id}/${restaurantCategories[0].id}`,
            { replace: true },
          );
        }
      }
      // window.scrollTo({
      //   top: 0,
      //   left: 0,
      // });
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [roomNumberInput, setRoomNumberInput] = useState("");
  const [roomError, setRoomError] = useState("");
  const [streetAddressError, setStreetAddressError] = useState("");
  const [validating, setValidating] = useState(false);

  useEffect(() => {
    if (require_room_number) {
      const sessionRoom = sessionStorage.getItem("validated_room_number");
      if (sessionRoom) {
        // Already validated this session — sync to localStorage for API calls
        localStorage.setItem("validated_room_number", sessionRoom);
      } else {
        // New session — clear any stale value and prompt the user
        localStorage.removeItem("validated_room_number");
        setShowRoomModal(true);
      }
    }
  }, [require_room_number]);

  const handleRoomNumberSubmit = async () => {
    console.log("Submitting room number:", streetAddress, business_name);
    // if (business_name === "Marriott Riyadh Airport" && !streetAddress.trim()) {
    //   setStreetAddressError(t("Street address is required."));
    //   return;
    // }
    if (!roomNumberInput.trim()) return;
    setValidating(true);
    setRoomError("");
    setStreetAddressError("");
    try {
      const res = await axios.post(
        `/${room_uuid}/restaurant/validate-room-number`,
        { room_number: roomNumberInput.trim() },
      );
      const isInvalid =
        res.data?.status === false ||
        res.data?.message === "Invalid Room Number";
      if (!isInvalid) {
        sessionStorage.setItem("validated_room_number", roomNumberInput.trim());
        localStorage.setItem("validated_room_number", roomNumberInput.trim());
        setShowRoomModal(false);
      } else {
        setRoomError(t("Invalid Room Number, please try again."));
      }
    } catch {
      setRoomError(t("Something went wrong, please try again."));
    } finally {
      setValidating(false);
    }
  };

  const toast = useRef(null);
  const [showCallWaiterModal, setShowCallWaiterModal] = useState(false);
  const [callWaiterLoading, setCallWaiterLoading] = useState(false);

  const handleCallWaiter = async () => {
    setCallWaiterLoading(true);
    try {
      await CallWaiter(room_uuid, restaurant_info.id);
      setShowCallWaiterModal(false);
      toast.current.show({
        severity: "success",
        summary: t("Success"),
        detail: t("Request received! A waiter will be with you shortly."),
        life: 4000,
      });
    } catch (e) {
      console.error("Call waiter failed", e);
      toast.current.show({
        severity: "error",
        summary: t("Error"),
        detail: t("Failed to call waiter. Please try again."),
        life: 4000,
      });
    } finally {
      setCallWaiterLoading(false);
    }
  };

  const imageref = useRef();
  const [height_res, setheight_res] = useState();
  useEffect(() => {
    // console.log("imageref00");
    if (imageref.current) {
      setheight_res(imageref.current.clientWidth);
      // console.log("imageref", imageref.current.clientWidth);
    }
  }, [data]);

  console.log(text, "text");
  return isLoading ? (
    <CarRentalLoader />
  ) : (
    <div className={theme ? "food" : ""}>
      {/* <HeaderInnerInDining
        bgColor={bgColor}
        color={color}
        languages={languages}
        theme={theme}
        hideIcon={hideIcon}
      /> */}
      {theme ? (
        <Title
          title={text}
          disableTitleNav={true}
          isDineIn={true}
          languages={fromRestaurantsList ? undefined : languages}
        />
      ) : (
        <HeaderInner
          headerName={text}
          color={color}
          disableTitleNav={true}
          isDineIn={true}
          languages={fromRestaurantsList ? undefined : languages}
          showLangSelect={!fromRestaurantsList}
        />
      )}
      <main className="bg-white pad-top-0 resturant_category">
        <>
          {images?.length > 0 &&
            (theme ? (
              <>
                <BannerHome
                  // className={"px-2"}
                  className={"bot_rad"}
                  headerImages={images}
                  isOverllay={true}
                  isVideo={isVideo}
                />
                <div
                  className={`res_info ${images?.length == 0 ? "mt-0" : ""}`}
                >
                  {" "}
                  <div className="res_name">
                    <h5 className="">
                      {" "}
                      {lang == "EN"
                        ? restaurant_info.display_name
                        : restaurant_info.name}
                    </h5>
                    <p>
                      {restaurant_info?.cuisines?.map((cuisine, idx) => {
                        if (idx + 1 < restaurant_info?.cuisines.length) {
                          return `${cuisine.name}  |  `;
                        } else {
                          return `${cuisine.name}  `;
                        }
                      })}
                    </p>
                  </div>
                  {restaurant_info.enable_call_waiter_requests &&
                    type === "in_dining" && (
                      <div className="mx-4 my-2">
                        <button
                          className="reg-btn  w-100"
                          onClick={() => setShowCallWaiterModal(true)}
                        >
                          {t("Call a Waiter")}
                        </button>
                      </div>
                    )}
                  {/* {restaurant_info?.show_booking == 1 && (
                <button
                  onClick={() =>
                    navigate(
                      `/${params.room_uuid}/BookTable/${restaurant_info.uuid}/${restaurant_info.id}?theme=true`
                    )
                  }
                  className="reg-btn"
                >
                  Book a Table
                </button>
              )} */}
                </div>
              </>
            ) : (
              <div>
                <header className="img-header m-0">
                  <Carosle headerImages={images} isVideo={isVideo} />
                </header>

                {get_open_check_available &&
                  get_open_check_available !== "false" && (
                    <div className="call-waiter">
                      <div className="mx-4 my-2">
                        <button
                          className="reg-btn  w-100"
                          onClick={() =>
                            navigate(
                              `/${room_uuid}/open-checkout?restaurant_id=${restaurant_info?.id}&restaurant_uuid=${restaurant_info?.uuid}`,
                            )
                          }
                        >
                          {t("View Bill")}
                        </button>
                      </div>
                    </div>
                  )}

                {restaurant_info.enable_call_waiter_requests && (
                  <div className="call-waiter">
                    <div className="mx-4 my-2">
                      <button
                        className="reg-btn  w-100"
                        onClick={() => setShowCallWaiterModal(true)}
                      >
                        {t("Call a Waiter")}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          {/* <div className="mx-4 my-2">
            <button
              className="reg-btn btn-primary w-100"
              onClick={handleCallWaiter}
              disabled={callWaiterLoading || callWaiterSuccess}
            >
              {callWaiterLoading
                ? t("Calling...")
                : callWaiterSuccess
                  ? t("Waiter Called!")
                  : t("Call Waiter")}
            </button>
          </div> */}
          {/* {restaurant_info.enable_call_waiter_requests && (
            <div className="mx-4 my-2">
              <button
                className="reg-btn  w-100"
                onClick={handleCallWaiter}
                disabled={callWaiterLoading || callWaiterSuccess}
              >
                {callWaiterLoading
                  ? t("Calling...")
                  : callWaiterSuccess
                    ? t("Waiter Called!")
                    : t("Call a Waiter")}
              </button>
            </div>
          )} */}
          <Search
            placeholder="Search for Categories..."
            room_uuid={room_uuid}
            category="Restaurant&in_dining"
          />
          {theme &&
            get_open_check_available &&
            get_open_check_available !== "false" && (
              <div className="themed-call-waiter">
                <div className="mx-4 my-2">
                  <button
                    className="reg-btn  w-100"
                    onClick={() =>
                      navigate(
                        `/${room_uuid}/open-checkout?restaurant_id=${restaurant_info?.id}&restaurant_uuid=${restaurant_info?.uuid}`,
                      )
                    }
                  >
                    {t("View Bill")}
                  </button>
                </div>
              </div>
            )}
          {terms_and_conditions != "" &&
            (terms_and_conditions != undefined ? (
              <>
                <div
                  className="mx-4 divhtml"
                  dangerouslySetInnerHTML={{
                    __html: terms_and_conditions,
                  }}
                />
              </>
            ) : null)}{" "}
          <ul
            className={`${
              restaurant_info?.squared_categories == 1 ? "res_sp" : ""
            }  display-list two-items restaurant-list mt-2 v2 ${
              restaurant_info?.resturant_name.includes("McDonald")
                ? "mcdonald"
                : ""
            } `}
          >
            {has_combo_meals && (
              <Zoom key={"001"}>
                <li className={"restaurant-option"}>
                  <Link
                    to={`/${room_uuid}/restaurant/combo-meals/${params.id}`}
                  >
                    <div className="closed-tag"></div> <div></div>
                    <div className="img-pnl">
                      <img src={CombImg} alt="" />
                    </div>
                    <div className="bg-layer"></div>
                    <p>{t("Combo Meals")}</p>
                  </Link>
                </li>
              </Zoom>
            )}
            {restaurantCategories
              ? restaurantCategories.map((category, idx) => {
                  console.log(category.name, encodeURI(category.image));
                  return (
                    <Zoom key={idx}>
                      <li
                        className={
                          category?.is_closed
                            ? "closed restaurant-option"
                            : "restaurant-option"
                        }
                        // /:room_uuid/RestaurantBooking/RestaurantMenu/:id/:restaurnat_id/:cat_id
                      >
                        <Link
                          to={
                            category.count_sub_categories != 0
                              ? `/${room_uuid}/rstauran-menu-subcategories/${params.id}/${category.id}`
                              : `/${room_uuid}/rstauran-menu-items/${params.id}/${category.id}`
                          }
                          ref={imageref}
                          style={
                            restaurant_info?.squared_categories == 1
                              ? { height: `${height_res}px` }
                              : { height: `140px` }
                          }
                        >
                          <div className="closed-tag"></div> <div></div>
                          {category?.is_closed && (
                            <span className="open_at">
                              {category.opens_at
                                ? `Opens at ${category.opens_at}`
                                : `Closed`}
                            </span>
                          )}
                          <div
                            className="img-pnl"
                            // style={{
                            //   backgroundImage: `url(${category.image})`,
                            // }}
                          >
                            <img src={encodeURI(category.image)} alt="" />
                          </div>
                          {/* {console.log(category.image.replace(/ /g, "%20"))} */}
                          <div className="bg-layer"></div>
                          <p>{category.name}</p>
                        </Link>
                      </li>
                    </Zoom>
                  );
                })
              : null}
          </ul>
        </>
      </main>

      <Modal
        show={showRoomModal}
        centered
        backdrop="static"
        keyboard={false}
        className={`custom-width pt-4 ${theme ? "food-modal" : ""}`}
      >
        <Modal.Body style={{ padding: "2rem" }}>
          <h5
            style={{
              color: theme ? "white" : "var(--color)",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {/* {t("Enter Room Number")} */}
            {/* {business_name === "Crowne Plaza Riyadh Palace"
              ? t("are you in crowne plaza riyadh palace?")
              : ""} */}
          </h5>
          {/* {business_name === "Marriott Riyadh Airport" && (
            <Form.Group className="mb-3 dark-placeholder i-f-small">
              <Form.Label style={{ color: theme ? "white" : "var(--color)" }}>
                {t("Street Address")}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={t("Street Address")}
                value={streetAddress}
                onChange={(e) => {
                  setStreetAddress(e.target.value);
                  setStreetAddressError("");
                }}
                onKeyDown={(e) => e.key === "Enter" && handleRoomNumberSubmit()}
                isInvalid={!!streetAddressError}
                autoFocus
              />
              {streetAddressError && (
                <Form.Control.Feedback type="invalid">
                  {streetAddressError}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          )} */}
          <Form.Group className="mb-3 dark-placeholder i-f-small">
            <Form.Label style={{ color: theme ? "white" : "var(--color)" }}>
              {" "}
              {business_name === "Crowne Plaza Riyadh Palace"
                ? t("Are you in Crowne Plaza Riyadh Palace?")
                : t("Are you in Marriott Riyadh AirPort?")}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Room Number")}
              value={roomNumberInput}
              onChange={(e) => {
                setRoomNumberInput(e.target.value);
                setRoomError("");
              }}
              onKeyDown={(e) => e.key === "Enter" && handleRoomNumberSubmit()}
              isInvalid={!!roomError}
              autoFocus
            />
            {roomError && (
              <Form.Control.Feedback type="invalid">
                {roomError}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <div className="text-center mt-3">
            <Button
              className="reg-btn book fw-normal"
              onClick={handleRoomNumberSubmit}
              disabled={
                !roomNumberInput.trim() ||
                // (business_name === "Marriott Riyadh Airport" &&
                //   !streetAddress.trim()) ||
                validating
              }
            >
              {validating ? t("Validating...") : t("Confirm")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCallWaiterModal}
        onHide={() => setShowCallWaiterModal(false)}
        backdrop="static"
        className={` ${theme && "food-modal"} rate_modal q_services_modal p-0`}
        style={{
          minHeight: "150px",
          padding: "0px !important",
          display: "flex !important",
          alignItems: "center !important",
          paddingRight: "0 !important",
        }}
      >
        <Modal.Body
          style={{ padding: "20px 10px", height: "auto" }}
          className=""
        >
          <h5 style={{ color: theme ? "#e7e7e7" : "var(--color)" }}>
            {t("Are you sure you want to call a waiter?")}
          </h5>
          <div className="servi_btns">
            <Button
              disabled={callWaiterLoading}
              className="no"
              style={{
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#ffd28d" : "var(--color)",
              }}
              onClick={() => setShowCallWaiterModal(false)}
            >
              {t("No")}
            </Button>
            <Button
              disabled={callWaiterLoading}
              className="yes"
              style={{
                background: theme ? "#ffd28d" : "var(--color)",
                borderColor: theme ? "#ffd28d" : "var(--color)",
                color: theme ? "#000" : "#fff",
              }}
              onClick={handleCallWaiter}
            >
              {t("Yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Toast ref={toast} position="bottom-center" />
    </div>
  );
}
export default InDiningScan;
